import { Search } from "@mui/icons-material";
import {
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  InputAdornment,
  MenuItem,
  Popover,
  Select,
  TextField,
} from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useEffect, useRef, useState } from "react";
import { CiFilter } from "react-icons/ci";
import { FaChevronDown } from "react-icons/fa";
import { IoMdAddCircleOutline } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import {
  exportInvoice,
  getInvoiceDetail,
  getInvoiceList,
} from "../../../services/invoiceApi";
import useDebounce from "../../hooks/useDebounce";
import moment from "moment";
import PagePagination from "../../common/particles.jsx/PagePagination";
import { BiPrinter } from "react-icons/bi";
import Cookies from "js-cookie";
import LoadingBackdrop from "../../common/particles.jsx/LoadingBackdrop";
import axios from "axios";
import PrintInvoice from "./PrintInvoice";
import { getSipaAndFullname, getUserProfile } from "../../../services/authApi";
import { useReactToPrint } from "react-to-print";
import PopupRangeCalendar from "../../common/particles.jsx/PopupRangeCalendar";
import ModalPaymentInvoice from "./modal/ModalPaymentInvoice";
import { AiOutlineDownload } from "react-icons/ai";

const toIDR = (val) =>
  val?.toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
  });
const token = () => Cookies.get("accessTokenOfficeOlin");

const InvoiceList = ({ isWarehouse }) => {
  const navigate = useNavigate();
  const componentRef = useRef();

  const [anchorElCal, setAnchorElCal] = useState(null);
  const [search, setSearch] = useState("");
  const [reqBody, setReqBody] = useState({
    offset: 1,
    limit: 10,
    status: 0,
    start_date: "",
    end_date: "",
    period: 0,
    warehouse: isWarehouse ? isWarehouse : false,
  });
  const [printArr, setPrintArr] = useState([]);
  const [isPrint, setIsPrint] = useState(false);
  const [dataInvArr, setDataInvArr] = useState([]);
  const [resLen, setResLen] = useState(0);
  const [selected, setSelected] = useState(null);
  const [openPay, setOpenPay] = useState(false);
  const [anchorElExport, setAnchorElExport] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [openCalendar, setOpenCalendar] = useState(false);

  const debounce = useDebounce(search, 500);

  const handleAddInvoice = (inv) => {
    var temp = [...printArr];
    if (printArr.some((item) => item.invoice_number === inv.invoice_number))
      temp = temp.filter((item) => item.invoice_number !== inv.invoice_number);
    else temp.push(inv);

    setPrintArr(temp);
  };

  const handleSelectAll = (checked) => {
    setPrintArr(checked ? [...dataList.data.map((item) => item)] : []);
  };

  const handleExport = (arr) => {
    setAnchorElExport(null);
    mutateExport({
      invoice_id: arr,
      warehouse: isWarehouse ? isWarehouse : false,
    });
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Faktur OLIN ${moment().format("YYYY-MM-DD hh:mm")}`,
  });

  const generatePrintInvoice = async (invNum) => {
    setIsPrint(true);
    var temp = [];

    axios
      .all([
        (invNum ? [invNum] : printArr.map((item) => item.invoice_number)).map(
          (num) =>
            axios({
              headers: {
                Authorization: `Bearer ${token()}`,
              },
              method: "GET",
              url: `${
                process.env.REACT_APP_API_PRODUCT
              }invoice/detail-invoice?invoice_number=${num}&company_user_id=${
                sipaAndFullnameData && sipaAndFullnameData !== undefined
                  ? profile && profile !== undefined
                    ? profile.id
                    : 0
                  : 0
              }&warehouse=${isWarehouse ? "true" : "false"}`,
            })
        ),
      ])
      .then((res) => {
        res.map((resData) => {
          setResLen(resData.length);
          resData.map((item) => {
            item.then((promiseRes) => {
              temp.push(promiseRes.data.detail);
              if (temp.length === resData.length) {
                setDataInvArr(temp);
              }
            });
          });
        });
      });
  };

  const {
    data: dataList,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["invoice-list", reqBody, debounce],
    queryFn: () =>
      getInvoiceList(
        reqBody.limit,
        reqBody.offset,
        debounce,
        reqBody.status,
        isWarehouse ? isWarehouse : false,
        reqBody.start_date,
        reqBody.end_date,
        reqBody.period === 10 ? 9 : reqBody.period
      ),
    refetchOnWindowFocus: false,
  });

  const { data: profile } = useQuery({
    queryKey: ["profile"],
    queryFn: () => getUserProfile(),
  });

  const { data: sipaAndFullnameData } = useQuery({
    queryKey: ["sipa-fullname", profile?.id],
    queryFn: () =>
      getSipaAndFullname(profile && profile !== undefined ? profile.id : 0),
  });

  const {
    data: dataDetail,
    isFetching: isFetchingDetail,
    refetch: refetchDetail,
  } = useQuery({
    queryKey: ["detail-invoice", selected],
    queryFn: () =>
      getInvoiceDetail(
        selected.invoice_number,
        isWarehouse ? isWarehouse : false
      ),
    enabled: selected !== null,
  });

  const { mutate: mutateExport, isLoading: isLoadingExport } = useMutation({
    mutationFn: exportInvoice,
    onSuccess: (xlsxData) => {
      const url = xlsxData;
      const a = document.createElement("a");
      a.download = `invoice-export-${moment().format("DD-MM-YYYY")}.xlsx`;
      a.href = url;

      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    },
  });

  useEffect(() => {
    if (dataInvArr.length > 0 && isPrint) {
      handlePrint();
      setIsPrint(false);
      setDataInvArr([]);
      setResLen(0);
    }
  }, [dataInvArr, resLen, isPrint]);

  useEffect(() => {
    setPrintArr([]);
  }, [reqBody, debounce]);

  useEffect(() => {
    setReqBody((prevVal) => ({ ...prevVal, offset: 1 }));
  }, [debounce]);

  return (
    <div>
      <div className="text-[12px] p-3 mb-[50px]">
        <LoadingBackdrop
          isLoading={isPrint || isFetchingDetail || isLoadingExport}
        />
        <div className="flex items-center gap-2 mb-2 overflow-x-auto">
          <TextField
            placeholder="Cari data"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment>
                  <Search />
                </InputAdornment>
              ),
            }}
            fullWidth
            sx={{ minWidth: "200px" }}
          />
          <Select
            value={reqBody.status}
            onChange={(e) =>
              setReqBody((prevVal) => ({ ...prevVal, status: e.target.value }))
            }
            sx={{ width: "100%" }}
          >
            <MenuItem value={0}>Semua Status</MenuItem>
            <MenuItem value={1}>Belum Bayar</MenuItem>
            <MenuItem value={2}>Belum Lunas</MenuItem>
            <MenuItem value={3}>Lunas</MenuItem>
          </Select>
          <Select
            sx={{ width: "100%" }}
            value={reqBody.period}
            onChange={(e) => {
              setReqBody((prevVal) => ({
                ...prevVal,
                period: e.target.value,
                start_date: "",
                end_date: "",
                offset: 1,
              }));
              setStartDate(null);
              setEndDate(null);
              if (e.target.value === 9) {
                setOpenCalendar(true);
                return;
              }
            }}
          >
            <MenuItem value={0}>Semua Periode</MenuItem>
            <MenuItem value={1}>Hari ini</MenuItem>
            <MenuItem value={2}>Kemarin</MenuItem>
            <MenuItem value={4}>Minggu Berjalan</MenuItem>
            <MenuItem value={3}>Minggu Lalu</MenuItem>
            <MenuItem value={6}>Bulan Berjalan</MenuItem>
            <MenuItem value={5}>Bulan Lalu</MenuItem>
            <MenuItem value={8}>Tahun Berjalan</MenuItem>
            <MenuItem value={7}>Tahun Lalu</MenuItem>
            <MenuItem value={9}>Pilih Tanggal</MenuItem>
            <MenuItem value={10} disabled sx={{ display: "none" }}>
              {moment(reqBody.start_date).format("DD/MM/YYYY") +
                " - " +
                moment(reqBody.end_date).format("DD/MM/YYYY")}
            </MenuItem>
          </Select>
          <button
            type="button"
            className="text-[12px] flex items-center gap-2 text-white bg-[#94C679] hover:bg-gray-300 rounded-md w-fit p-2 whitespace-nowrap border-2 border-green-500"
            onClick={(e) => setAnchorElExport(e.currentTarget)}
          >
            <AiOutlineDownload />
            Export
          </button>
          <button
            className="disabled:bg-gray-300 disabled:text-white text-blue-500 border-2 border-blue-500 rounded-md hover:bg-slate-100 w-fit flex items-center justify-center p-2"
            onClick={() => generatePrintInvoice()}
            disabled={printArr.length === 0 || isPrint}
          >
            {isPrint ? (
              <CircularProgress size={15} />
            ) : (
              <>
                <BiPrinter className="text-[18px]" />
              </>
            )}
          </button>
          <button
            type="button"
            className="border rounded-md flex items-center justify-between gap-2 w-fit py-2.5 px-2 bg-blue-500 text-white hover:bg-gray-300 whitespace-nowrap text-nowrap"
            onClick={() =>
              navigate(
                `${
                  isWarehouse ? "/central-warehouse" : ""
                }/invoice/invoice/create-invoice`
              )
            }
          >
            Tambah Faktur
            <IoMdAddCircleOutline className="text-[18px]" />
          </button>
        </div>

        <div className="flex w-full mb-8">
          <div className="w-full">
            <div className="block overflow-x-auto w-full rounded-md">
              <table className="w-full overflow-x-auto rounded-md border-collapse">
                <thead className="bg-blue-500 text-white">
                  <th className="p-2 text-center">
                    <Checkbox
                      disabled={
                        !dataList || isFetching || (dataList && !dataList?.data)
                      }
                      checked={
                        !dataList || isFetching || (dataList && !dataList?.data)
                          ? false
                          : printArr.length > 0 &&
                            printArr.length === dataList.data.length
                      }
                      onChange={(e, checked) => handleSelectAll(checked)}
                    />
                  </th>
                  <th className="p-2 text-center">No</th>
                  <th className="p-2 text-center whitespace-nowrap">
                    Tanggal Faktur
                  </th>
                  <th className="p-2 text-center whitespace-nowrap">
                    No. Invoice
                  </th>
                  <th className="p-2 text-center whitespace-nowrap">
                    No. Faktur Pajak
                  </th>
                  <th className="p-2 text-center whitespace-nowrap">
                    Customer
                  </th>
                  <th className="p-2 text-center whitespace-nowrap">
                    Total Tagihan
                  </th>
                  <th className="p-2 text-center whitespace-nowrap">
                    Total Dibayar
                  </th>
                  <th className="p-2 text-center whitespace-nowrap">
                    Jatuh Tempo
                  </th>
                  <th className="p-2 text-center whitespace-nowrap">
                    Tanggal Pembayaran
                  </th>
                  <th className="p-2 text-center whitespace-nowrap">
                    Metode Pembayaran
                  </th>
                  <th className="p-2 text-center whitespace-nowrap">Status</th>
                  <th className="p-2 text-center whitespace-nowrap">Action</th>
                </thead>
                <tbody className="border">
                  {dataList && !isFetching && dataList.data ? (
                    dataList.data.map((item, i) => (
                      <tr key={i} className={`${i === 0 ? "" : "border-t"}`}>
                        <td className="p-2 text-center">
                          <Checkbox
                            onChange={() => handleAddInvoice(item)}
                            checked={printArr.some(
                              (print) =>
                                print.invoice_number === item.invoice_number
                            )}
                          />
                        </td>
                        <td className="p-2 text-center">
                          {(reqBody.offset - 1) * reqBody.limit + (i + 1)}
                        </td>
                        <td className="p-2 text-center">
                          {moment(item.invoice_date).format("DD/MM/YYYY")}
                        </td>
                        <td className="p-2 text-center">
                          {item.invoice_number}
                        </td>
                        <td className="p-2 text-center">
                          {item.faktur_number === "" ? "-" : item.faktur_number}
                        </td>
                        <td className="p-2 text-center">
                          {item.customer_name}
                        </td>
                        <td className="p-2 text-center">
                          {toIDR(item.total_grand)}
                        </td>
                        <td className="p-2 text-center">
                          {toIDR(item.total_amount)}
                        </td>
                        <td className="p-2 text-center">
                          {moment(item.due_date).format("DD/MM/YYYY")}
                        </td>
                        <td className="p-2 text-center">
                          {item.paid_at === ""
                            ? "-"
                            : moment(item.paid_at).format("DD/MM/YYYY")}
                        </td>
                        <td className="p-2 text-center">
                          {item.payment_method === ""
                            ? "-"
                            : item.payment_method}
                        </td>
                        <td
                          className={`p-2 text-center whitespace-nowrap font-semibold ${
                            item.status === 1
                              ? ""
                              : item.status === 2
                              ? "text-amber-500"
                              : item.status === 3
                              ? "text-green-500"
                              : item.status === 4
                              ? "text-red-500"
                              : ""
                          }`}
                        >
                          {item.status === 1
                            ? "Belum bayar"
                            : item.status === 2
                            ? "Belum lunas"
                            : item.status === 3
                            ? "Lunas"
                            : item.status === 4
                            ? "Telat Bayar"
                            : "-"}
                        </td>
                        <td className="p-2 text-center">
                          <div className="w-full flex gap-2 items-center">
                            <a
                              className="bg-gray-100 border-gray-300 text-gray-500 border-2 rounded-md w-full hover:bg-gray-300 p-1 disabled:border-none disabled:bg-gray-300 disabled:text-white"
                              href={`${
                                isWarehouse ? "/central-warehouse" : ""
                              }/invoice/invoice/detail-invoice/${item.invoice_number.replaceAll(
                                "/",
                                "="
                              )}`}
                            >
                              Detail
                            </a>
                            <button
                              className="bg-blue-100 text-blue-500 border-2 rounded-md w-full hover:bg-blue-300 p-1 disabled:bg-gray-300 disabled:text-white"
                              type="button"
                              onClick={() => {
                                generatePrintInvoice(item.invoice_number);
                              }}
                            >
                              Print
                            </button>
                            <button
                              className="bg-green-100 text-green-500 border-2 rounded-md w-full hover:bg-green-300 p-1 disabled:bg-gray-300 disabled:text-white"
                              type="button"
                              disabled={item.status === 3}
                              onClick={() => {
                                setSelected(item);
                                setOpenPay(true);
                              }}
                            >
                              Bayar
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr className="border">
                      <td className="p-2 text-center" colSpan={13}>
                        {isFetching ? (
                          <CircularProgress size={20} />
                        ) : (
                          "Tidak ada data"
                        )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {dataList && dataList.total > 0 && dataList.data !== null ? (
          <div className="mb-4">
            <PagePagination
              offset={reqBody.offset}
              setOffset={(e) =>
                setReqBody((prevVal) => ({ ...prevVal, offset: e }))
              }
              limit={reqBody.limit}
              setLimit={(e) =>
                setReqBody((prevVal) => ({ ...prevVal, limit: e }))
              }
              total={dataList.total}
            />
          </div>
        ) : null}
      </div>

      <div
        className={`bg-white fixed bottom-0 left-0 lg:left-[260px] min-h-[60px] px-[20px] py-[10px] w-full lg:w-[calc(100%-260px)] shadow-lg shadow-slate-900/20 shadow-b-2 shadow-r-[3px] -shadow-spread-2 text-[12px] flex items-center z-50`}
      >
        <div className="flex items-center justify-between items-center w-full">
          {isFetching ? (
            <CircularProgress size={20} />
          ) : dataList && !isFetching ? (
            <div>
              <p>{dataList.total > 0 ? dataList.date : ""}</p>
              <div className="flex gap-4">
                <p>
                  Total Tagihan :{" "}
                  <span className="text-[16px] font-bold">
                    {toIDR(dataList.total_bill ? dataList.total_bill : 0)}
                  </span>
                </p>
                <p>
                  Total Dibayar :{" "}
                  <span className="text-[16px] font-bold">
                    {toIDR(dataList.total_payment ? dataList.total_payment : 0)}
                  </span>
                </p>
              </div>
            </div>
          ) : null}
        </div>
      </div>

      <div className="" ref={componentRef}>
        <PrintInvoice
          dataInvArr={dataInvArr}
          sipaAndFullnameData={sipaAndFullnameData}
        />
      </div>

      {dataDetail ? (
        <ModalPaymentInvoice
          open={openPay}
          setOpen={setOpenPay}
          invoice={dataDetail ? dataDetail : null}
          refetch={() => {
            setReqBody({
              offset: 1,
              limit: 10,
              status: 0,
              start_date: "",
              end_date: "",
              warehouse: isWarehouse ? isWarehouse : false,
            });
            refetch();
          }}
          isFromList={true}
          setSelected={setSelected}
          isWarehouse={isWarehouse}
        />
      ) : null}

      <Dialog
        open={openCalendar}
        onClose={() => {
          setOpenCalendar(false);
        }}
      >
        <DialogTitle>Pilih Tanggal</DialogTitle>
        <DialogContent>
          <div className="flex">
            <DatePicker
              selected={startDate}
              onChange={(dates) => {
                const [start, end] = dates;
                setStartDate(start);
                setEndDate(end);
              }}
              startDate={startDate}
              endDate={endDate}
              selectsRange
              inline
            />
          </div>
          <button
            className="bg-indigo-500 rounded text-white px-2 py-1 font-semibold w-full"
            onClick={() => {
              setOpenCalendar(false);
              setReqBody((prevVal) => ({
                ...prevVal,
                period: 10,
                start_date: startDate
                  ? moment(startDate).format("YYYY-MM-DD")
                  : "",
                end_date: endDate ? moment(endDate).format("YYYY-MM-DD") : "",
              }));
            }}
          >
            Konfirmasi
          </button>
        </DialogContent>
      </Dialog>

      <Popover
        open={Boolean(anchorElExport)}
        anchorEl={anchorElExport}
        onClose={() => setAnchorElExport(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div className="w-full">
          <p
            className={`px-8 py-2 border-b-2  ${
              printArr.length === 0
                ? "bg-gray-300 text-white cursor-default"
                : "cursor-pointer hover:bg-gray-100"
            }`}
            onClick={() => {
              if (printArr.length > 0)
                handleExport(printArr.map((item) => item.id));
            }}
          >
            Stok Terpilih
          </p>
          <p
            className="px-8 py-2  cursor-pointer hover:bg-gray-100"
            onClick={() => handleExport([])}
          >
            Semua Stok
          </p>
        </div>
      </Popover>
    </div>
  );
};

export default InvoiceList;
